import type { TryOnPublishableKey } from "services/adminApi"

export type TryOnKeysList = { items: TryOnPublishableKey[] }

/**
 * The create/update/revoke endpoints return the full authoritative key record,
 * so the cached list is patched straight from the response instead of paying a
 * second round-trip through a cold Lambda — the same fix as the 3D twin
 * (`viewer3DKeysCache.ts`), keyed by `keyId` instead of `keyHash`.
 *
 * `previous` is optional: a disabled query registers a cache entry whose data
 * is `undefined`.
 */
export const upsertTryOnKey = (
  previous: TryOnKeysList | undefined,
  key: TryOnPublishableKey
): TryOnKeysList | undefined => {
  if (!previous) return previous
  if (!previous.items.some((item) => item.keyId === key.keyId))
    // Unknown keyId = create. Order is irrelevant: the page re-sorts by createdAt.
    return { ...previous, items: [...previous.items, key] }

  return {
    ...previous,
    items: previous.items.map((item) => (item.keyId === key.keyId ? key : item)),
  }
}

export const removeTryOnKey = (
  previous: TryOnKeysList | undefined,
  keyId: string
): TryOnKeysList | undefined => {
  if (!previous) return previous
  if (!previous.items.some((item) => item.keyId === keyId)) return previous
  return { ...previous, items: previous.items.filter((item) => item.keyId !== keyId) }
}
